import * as R from 'ramda';
import CustomError from './customError';

export default class NetworkError extends CustomError {
  public networkErrorCode: number;

  constructor(message: string, networkErrorCode: number, nestedError?: Error) {
    super(message, nestedError);
    this.networkErrorCode = networkErrorCode;
  }
}

export const isNetworkError = R.curry((errorCode: number, error: Error): boolean => {
  if (R.is(NetworkError, error)) {
    const networkError = error as NetworkError;
    return errorCode === networkError.networkErrorCode;
  }

  return false;
});
